import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '@core/services/session.service';

export const adminWithdrawGuard: CanActivateFn = (route, state) => {
  const sessionService = inject(SessionService);
  const router = inject(Router);

  if (sessionService.isAvailableAdminWithdraw()) {
    return true;
  }

  router.navigate(['/admin/users']);
  return false;
};
